import { render, staticRenderFns } from "./SubPage2.vue?vue&type=template&id=63545cf0&scoped=true&"
import script from "./SubPage2.vue?vue&type=script&lang=js&"
export * from "./SubPage2.vue?vue&type=script&lang=js&"
import style0 from "./SubPage2.vue?vue&type=style&index=0&id=63545cf0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63545cf0",
  null
  
)

export default component.exports